import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import { AppProviders } from "./app/app-providers";

import "./locales/i18n-provider";

const container = document.getElementById("app");
if (!container) {
	throw new Error("Missing #app root element");
}

createRoot(container).render(
	<StrictMode>
		<AppProviders>
			<App />
		</AppProviders>
	</StrictMode>
);
